// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3g4gS","inputWrap":"styles_inputWrap__3kqug","input":"styles_input__1DYSo"};